import Cookie from 'universal-cookie'
import { setStorage } from '~/utils/storage'
import resource from '@/api/resource'
import { EventBus } from '@/plugins/event-bus'
const cookie = new Cookie()

export default function () {
  const globalSsoToken = cookie.get('global_sso_token')
  const globalRefreshToken = cookie.get('global_sso_refresh_token')
  const globalValidUntil = cookie.get('global_sso_valid_until')

  const isSyncAuth = cookie.get('is_sync_auth')

  const TOKEN_KEY = 'qontak._token.hub'
  const REFRESH_TOKEN_KEY = 'qontak._refresh_token.hub'
  const VALID_UNTIL_KEY = 'qontak._token.hub.valid_until'
  const IS_SYNC_AUTH = 'is_sync_auth'

  return new Promise((resolve) => {
    if (!globalSsoToken || !isSyncAuth || isSyncAuth === '0') {
      resolve()
      return
    }

    resource
      .get('/api/core/v1/client_configs/config')
      .then((response) => {
        const appconfig = response.data.data
        if (appconfig.is_sync_auth) {
          // Set token
          setStorage(TOKEN_KEY, globalSsoToken, {
            expires: new Date(globalValidUntil),
          })
          setStorage(REFRESH_TOKEN_KEY, globalRefreshToken, {
            expires: new Date(globalValidUntil),
          })
          setStorage(VALID_UNTIL_KEY, globalValidUntil, {
            expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days
          })

          setStorage(IS_SYNC_AUTH, '0', {
            domain: process.env.HOST_URL,
            expires: new Date(globalValidUntil),
          })

          // Trigger MQTT reinitialization after token sync
          EventBus.$emit('re-initialize-mqtt')
        } else {
          console.error('Appconfig is_sync_auth is false')
        }
      })
      .finally(() => {
        resolve()
      })
  })
}
